import { cn } from '../lib/cn';
import { Card } from './ui';

function Sparkline({ points }: { points: number[] }): JSX.Element {
  const w = 80;
  const h = 24;
  const max = Math.max(...points);
  const min = Math.min(...points);
  const span = max - min || 1;
  const coords = points
    .map((p, i) => `${(i / (points.length - 1)) * w},${h - ((p - min) / span) * h}`)
    .join(' ');
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="h-6 w-20" preserveAspectRatio="none" aria-hidden>
      <polyline points={coords} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}

/**
 * KPI-Karte im Tremor-/Stripe-Stil (Zahl + Trend + Sparkline). Werte sind aktuell
 * Platzhalter (0/—), bis Premium-Daten (gespeicherte Container) vorliegen.
 */
export function KpiCard({
  title,
  value,
  delta,
  trend = 'flat',
  spark,
}: {
  title: string;
  value: string | number;
  delta?: string;
  trend?: 'up' | 'down' | 'flat';
  spark?: number[];
}): JSX.Element {
  const trendCls =
    trend === 'up' ? 'text-status-ok' : trend === 'down' ? 'text-status-problem' : 'text-muted-foreground';
  return (
    <Card className="p-4">
      <p className="text-sm text-muted-foreground">{title}</p>
      <div className="mt-1.5 flex items-end justify-between gap-2">
        <span className="text-2xl font-semibold tracking-tight">{value}</span>
        {spark && <span className={cn('opacity-60', trendCls)}>{<Sparkline points={spark} />}</span>}
      </div>
      {delta && <p className={cn('mt-1 text-xs font-medium', trendCls)}>{delta}</p>}
    </Card>
  );
}
